<template>
  <div v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" class="yz-table" :class="theme">
    <el-table :ref="instance" v-bind="$attrs" v-on="$listeners" :stripe="stripe" :data="innerData" @sort-change="sorting">
      <template v-for="(item, index) in innerColumn">
        <el-table-column v-if="item.type !== 'selection' && item.type !== 'index'" :key="index" :label="item.label"
          :type="item.type" :width="item.width" :min-width="item.minWidth" :class-name="item.class"
          :label-class-name="item.labelClass" :sortable="item.sort ? item.sort : false" :align="item.align ? item.align : 'left'">
          <template slot="header">
            <component v-if="item.renderHeader" :is="item.renderHeader" :row="row" :cusprop="item.cusprop" />
            <span v-else>{{ item.label }}</span>
          </template>
          <template slot-scope="{ row }">
            <div v-if="!item.component">
              {{ rootFilters(getValue(row, item.prop), item.filter) }}
            </div>
            <div v-else>
              <component v-if="typeof item.component === 'string'" :is="item.component" :row="row"
                :cusprop="item.cusprop" />
              <template v-else>
                <component v-for="(value, o_i) in item.component" :key="o_i + 'component'" :is="item.component[o_i]"
                  :row="row" :cusprop="item.cusprop[o_i]" />
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.type" :label="item.label" :key="index + 'type'" :type="item.type"
          :class-name="item.className" :index="index" />
      </template>
    </el-table>

    <!--后备内容-->
    <!--具名插槽-->
    <!--作用域插槽-->
    <div v-if="hasPage && pageObj.total > 0" class="pagination-container">
      <slot v-bind:pageObj="pageObj" name="paging">
        <el-pagination :background="true" :popper-class="'yz-page-select'" :current-page.sync="innerSearchForm.page"
          :page-size.sync="innerSearchForm.pageSize" layout="slot, prev, pager, next, sizes, jumper"
          :page-sizes="pageSizes" :total="pageObj.total" @size-change="sizeChangePage"
          @current-change="handleCurrentChange">
          <span class="pag-total">{{ totalTxt }}</span>
        </el-pagination>
      </slot>
    </div>
  </div>
</template>
<script>
//通用Table3.0需求：
//1、原生属性和事件全部保留（完成）
//2、皮肤自定义（完成）
//3、url配置修改（完成）
//4、内置分页插件（完成）
//5、新增接口预处理（完成）
//6、查询数据对外部开放（完成）
//7、自定义头部（完成）
//8、内置sorting（完成）
//9、依赖axios，el-table，el-pagination（完成）
//10、 动态filter（完成）
import axios from "axios";
import { getToken } from "@/utils/auth.js";
export default {
  name: "Yz-Table",
  props: {
    // 斑马条纹
    stripe: {
      type: Boolean,
      default: true,
    },
    //是否存在分页
    hasPage: {
      type: Boolean,
      default: true,
    },
    //是否自动加载数据
    autoLoad: {
      type: Boolean,
      default: true,
    },
    //列表接口地址
    listApi: {
      type: String,
      default: "",
    },
    //列表接口地址
    listApiLocal: {
      type: String,
      default: "",
    },
    //表头配置接口
    columnApi: {
      type: String,
      default: "",
    },
    //自定义主题
    theme: {
      type: String,
      default: "",
    },
    //查询参数
    searchForm: {
      type: Object,
      default: function () {
        return {};
      },
    },
    //页码
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 40, 50];
      },
    },
    //获取数据
    getData: {
      type: Function,
      default: null,
    },
    getDataAll: {
      type: Function,
      default: null,
    },
    afterRequest: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      pageObj: {
        total: 0,
      },
      innerData: [],
      innerColumn: [],
      innerSearchForm: {},
      instance: "",
    };
  },
  computed: {
    totalTxt() {
      return `共${this.pageObj.total}条记录 第${this.innerSearchForm.page}/${this.totalPage}页`;
    },
    totalPage() {
      return Math.ceil(this.pageObj.total / this.innerSearchForm.pageSize);
    },
  },
  async created() {
    this.loading = this.autoLoad;
    this.instance = new Date().getTime() + "el";
    var searchForm = JSON.stringify(this.searchForm || {});
    this.innerSearchForm = JSON.parse(searchForm); //深克隆
    await this.getColumns(); //取表头
    if (this.autoLoad) {
      await this.getList({}, true); //取数据
    }
  },
  methods: {
    rootFilters(val, filter) {
      const mth = this.$options.filters[filter];
      return (mth && mth(val)) || val;
    },
    //获取el-Table实例用于自由化实现功能
    getInstance() {
      return this.$refs[this.instance];
    },
    //获取表格数据
    getInnerData() {
      return this.innerData;
    },
    //表头数据
    async getColumns() {
      var res = await axios.get(this.columnApi);
      this.innerColumn = res.data;
    },
    //列表数据
    async getList(searchForm, loading) {
      console.log('**searchForm**',searchForm)
      this.loading = loading;
      searchForm = searchForm || {};
      var params_union = { ...this.innerSearchForm, ...searchForm };
      var params = JSON.parse(JSON.stringify(params_union)); //防止影响UI界面
      this.innerSearchForm = params;
      //this.filterParams(params); //参数过滤
      try {
        var apiUrl = this.listApi;
        var response = await axios.get(apiUrl, {
          params: params,
          headers: { token: getToken() },
        });

        var res = response.data;
        if (typeof this.afterRequest == "function") {
          res = this.afterRequest(res);
        }
        var data = res.result || {};
        this.innerData = data.items || [];
        this.pageObj.total = data.total || 0;
        this.loading = false;

        if (typeof this.getData == "function") {
          this.getData(res, this.pageObj);
        }
      } catch (error) {
        console.error(error);
      }
    },
    filterData(data, conditions) {
      const isNameConditionPresent = conditions.name !== undefined;
      const isModel = conditions.aircraftModel !== undefined;
      const modelName = isModel ? conditions.aircraftModel.trim() : '';

      // 去除空格
      const filterName = isNameConditionPresent ? conditions.name.trim() : '';

      // 日期判断
      const isDateRangePresent = conditions.beginTime && conditions.endTime;
      const beginTime = isDateRangePresent ? new Date(conditions.beginTime) : null;
      const endTime = isDateRangePresent ? new Date(conditions.endTime) : null;

      return data.filter(item => {
          const takeoffDate = new Date(item.takeoffTime);
          const landingDate = new Date(item.landingTime);
          
          const isNameMatch = isNameConditionPresent ? (item.name.trim()).indexOf(filterName) != -1 : true;

          // 日期范围判断
          const isWithinDateRange = !isDateRangePresent || (takeoffDate >= beginTime && landingDate <= endTime);

          // 飞机型号判断
          const isAircraftModel = isModel ? (item.aircraftModel.trim()).indexOf(modelName) != -1 : true;

          return isNameMatch && isWithinDateRange && isAircraftModel;
      });
    },
    //参数过滤
    filterParams(params) {
      for (let key in params) {
        if (typeof params[key] === "string") {
          params[key] = params[key].trim();
          //params[key] = encodeURIComponent(params[key].trim());
        }
        if (params[key] === "") {
          params[key] = undefined;
        }
        if (params[key] === null) {
          params[key] = undefined;
        }
        if (params[key] instanceof Array) {
          params[key] = params[key].join(",");
        }
        if (params[key] === "") {
          params[key] = undefined;
        }
      }
    },
    sorting({ column }) {
      let order = column.order;
      let sort = column.sortable;
      this.innerSearchForm.od = sort;
      if (order === "ascending") {
        // 正序 console.log('↑日期由远到近')
        this.innerSearchForm.ac = "asc";
      } else if (order === "descending") {
        // 倒序 console.log('↑日期由近到远')
        this.innerSearchForm.ac = "desc";
      } else {
        this.innerSearchForm.od = undefined;
      }
      this.getList({}, true); //刷新页面
    },
    sizeChangePage(obj) {
      this.innerSearchForm.pageSize = obj;
      this.getList({}, true); //刷新页面
    },
    handleCurrentChange(obj) {
      this.innerSearchForm.page = obj;
      this.getList({}, true); //刷新页面
    },
    getValue(row, prop) {
      if (!prop) return "-";
      if (prop.indexOf(".") > -1) {
        return this.$jsonPath(row, prop) ? this.$jsonPath(row, prop) : "-";
      }
      if (row[prop] === "" || row[prop] === null || row[prop] === undefined) {
        return "-";
      }
      return row[prop];
    },
  },
};
</script>
